import { BID_AGGREGATOR_BASE_URL } from 'global/environment';
import { postRequest } from 'utils/http';
import { options } from 'global/bankID';

export async function checkBankIDOrderStatus(orderRef) {
  const bankIDStatusUrl = `${BID_AGGREGATOR_BASE_URL}/bid/collect`;
  return postRequest(bankIDStatusUrl, { orderRef }, options);
}

export async function cancelBankIDOrderAPI(orderRef) {
  const cancelBankIDLoginURL = `${BID_AGGREGATOR_BASE_URL}/bid/cancel`;
  return postRequest(cancelBankIDLoginURL, { orderRef }, options);
}
